exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".labels-grid thead th:first-child {\n  width: 20%; }\n\n.labels-grid__input {\n  border: 1px solid transparent;\n  border-radius: .25rem;\n  margin: -1rem -1.25rem;\n  padding: 1.25rem 1rem;\n  width: calc(100% + 2.5rem);\n  background-color: transparent;\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  overflow: hidden;\n  resize: vertical;\n  outline: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/pages/pages/search/labelsGrid/LabelsGrid.scss
// module id = 1380
// module chunks = 0